import React, { useState } from 'react';
import { Row, Col, Form, Spinner } from 'reactstrap';
import Select from 'react-select';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import toast from 'react-hot-toast';
import { SHOWROOM_NAMES } from '../../../../constants/showRoomCodes';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import UserAuthKey from '../../../../components/Common/UserAuthKey';

const omsNestApiUrl = process.env.REACT_APP_SMILES_SERVICE_REST_ENDPOINT;
const ManageStoreRefundExport = () => {
    const [status, setStatus] = useState(null);
    const [store, setStore] = useState(null);
    const [startDate, setStartDate] = useState(
        new moment(new Date()).format('YYYY-MM-DD')
    );
    const [endDate, setEndDate] = useState(
        new moment(new Date()).format('YYYY-MM-DD')
    );
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    let UserRoleID = '';
    let UserCountry = '';
    let UserStore = '';
    let UserEmail = '';
    let UserName = '';

  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
      UserStore = userObj?.stores;
      UserEmail = userObj?.user_email;
      UserName = userObj?.user_name;

    }
  }

    const statusOptions = [
        { value: 'all', label: 'All' },
        { value: 'pending', label: 'Pending' },
        { value: 'approved', label: 'Approved' },
    ];

    // Build storeOptions from SHOWROOM_NAMES (use key as value for matching)
    let storeOptions = [
        { value: 'all', label: 'All' },
        ...Object.entries(SHOWROOM_NAMES).map(([key, label]) => ({ value: key, label }))
    ];

    // Restrict storeOptions based on UserRoleID and UserStore
    if (UserRoleID !== '1' && UserStore) {
        const userStoresArr = Array.isArray(UserStore)
            ? UserStore
            : String(UserStore).split(',').map(s => s.trim());
        storeOptions = storeOptions.filter(opt => userStoresArr.includes(opt.value));
    }

    const excelGenerate = async (params) => {
        const bearerToken = UserAuthKey();
        const config = {
            method: 'POST',
            url: `${omsNestApiUrl}/automation/refunds-report`,
            headers: {
                Authorization: `Bearer ${bearerToken}`,
                'Content-Type': 'application/json',
            },
            data: {
                ...params,
            },
        };
        try {
            const response = await axios(config);
            setLoading(false);
            console.log('response', response);
            if (response?.data?.status === 'success') {
                toast.success('Export successful! You will receive an email shortly or you can check in the Reports section.');
                // window.location.href = response.data.data[0].report_link;
            } else {
                toast.error('Export failed. No report link found.');
            }
        } catch (error) {
            setLoading(false);
            toast.error('Export failed.');
            console.log(error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // if (!status || !store) {
        //     toast.error('Please select both Status and Store.');
        //     return;
        // }
        setLoading(true);
        const storeCode = UserStore === 'ALL' ? store.value : UserStore;
        excelGenerate({
            exportType: 'StoreRefunds',
            dateFrom: startDate,
            dateTo: endDate === undefined || endDate === '' ? startDate : endDate,
            country: 'ae',
            status: status.value,
            storeCode,
            userId: UserRoleID,
            email: UserEmail,
            name: UserName
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="align-items-center justify-content-between" style={{ height: '100%' }}>
                <Col>
                    <Select
                        options={statusOptions}
                        placeholder="Select Status"
                        onChange={(selectedOption) => setStatus(selectedOption)}
                    />
                </Col>
                {UserStore === 'ALL' && (
                <Col>
                    <Select
                        options={storeOptions}
                        placeholder="Select Store"
                        onChange={(selectedOption) => setStore(selectedOption)}
                    />
                </Col>
                )}
                <Col>
                    <DateRangePicker
                        placeholder="Select Date Range"
                        placement="auto"
                        onChange={(selectedDates) => {
                            const start = moment(selectedDates[0]).format('YYYY-MM-DD');
                            const end = moment(selectedDates[1]).format('YYYY-MM-DD');
                            setStartDate(start);
                            setEndDate(end);
                        }}
                    />
                </Col>
                <Col xs="12" sm="6" md="2">
                    <button type="submit" className="btn btn-dark w-100" disabled={loading} style={{ display: 'flex' }}>
                        {loading ? <Spinner size="sm" /> : 'Export'}
                        <i className="bx bx-download" style={{ padding: '3px' }}></i>
                    </button>
                </Col>
            </Row>
        </Form>
    );
};

export default ManageStoreRefundExport;
